import { useMutation, useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { omit } from 'ramda';
import { UserRewardStatus } from '../../constants';
import { useCountry } from '../../components/CountrySelector';
import { useUser, USER_QUERY } from '../useUser';
import { UseUserQuery } from '../../generated/types/UseUserQuery';
import { ENROLL_MUTATION, EnrollMutation, EnrollMutationVariables } from './useEnrollMutation.rest';

export const useEnrollMutation = () => {
  const client = useApolloClient();
  const { country } = useCountry();

  const { setUserData } = useUser();
  const [mutate, { loading, error }] = useMutation<EnrollMutation, EnrollMutationVariables>(
    ENROLL_MUTATION
  );

  const handleEnroll = useCallback(async () => {
    const {
      data: { user }
    } = await client.query<UseUserQuery>({ query: USER_QUERY });

    if (!user) return;

    if (user.id) {
      await mutate({
        variables: {
          id: user.id,
          input: {
            data: {
              type: 'users',
              attributes: {
                country_code: country.alpha2Code,
                enroll_to_loyalty: true
              },
              id: user.id
            }
          }
        }
      });
      setUserData({
        ...omit(['__typename'], user),
        userLoyaltyStatus: UserRewardStatus.Enrolled
      });

      return Promise.resolve();
    }

    return Promise.reject('User id not found.');
  }, [client, country.alpha2Code, mutate, setUserData]);

  return { handleEnroll, loading, error };
};
